import { AdminListView } from "./AdminListView";
import { recoveryTeamAdapter } from "./recoveryTeamAdapter";

export function RecoveryTeamAdminPage() {
  return <AdminListView adapter={recoveryTeamAdapter} />;
}
